import Cookie from "js-cookie";
import { path, pathEq } from "ramda";
import { useEffect } from "react";

import { hasData } from "../../../packages/fp";
import isGDPR from "../helpers/isGDPR";
import { EVIDON_GDPR_CONSENT_COOKIE } from "../constants";

const EVIDON_PREFERENCES_ACCEPT_BTN_ID = "evidon-prefdiag-accept";
const EVIDON_BANNER_ACCEPT_BTN_ID = "_evidon-accept-button";
const EVIDON_PREFERENCES_CHANGE_RELOAD_DELAY = 100;
const EVIDON_ACCEPT_BUTTON_RELOAD_DELAY = 1000;

const isBannerAcceptButtonClicked = pathEq(EVIDON_BANNER_ACCEPT_BTN_ID, [
  "target",
  "id",
]);

const isPreferencesAcceptButtonClicked = pathEq(
  EVIDON_PREFERENCES_ACCEPT_BTN_ID,
  ["target", "id"]
);

const setEvidonGDPRConsentCookie = () => {
  Cookie.set(EVIDON_GDPR_CONSENT_COOKIE, 1, {
    path: window.evidon.notice._getConsentCookieDomainPath(),
    expires: window.evidon.notice._getConsentCookieExpDate(),
  });
};

const haveEvidonCategoriesLoaded = () =>
  hasData(path(["optOutDetails", "categories"], window.evidon.notice));

const handleEvidonConsentButtonClick = (e) => {
  if (isBannerAcceptButtonClicked(e) && isGDPR()) {
    setEvidonGDPRConsentCookie();
    setTimeout(
      () => window.location.reload(),
      EVIDON_ACCEPT_BUTTON_RELOAD_DELAY
    );
  }

  if (isPreferencesAcceptButtonClicked(e) && haveEvidonCategoriesLoaded()) {
    if (isGDPR() && !Cookie.get(EVIDON_GDPR_CONSENT_COOKIE)) {
      setEvidonGDPRConsentCookie();
    }

    setTimeout(
      () => window.location.reload(),
      EVIDON_PREFERENCES_CHANGE_RELOAD_DELAY
    );
  }
};

const EvidonSetConsentHotfix = () => {
  useEffect(() => {
    document.addEventListener("click", handleEvidonConsentButtonClick);

    return () => {
      document.removeEventListener("click", handleEvidonConsentButtonClick);
    };
  }, []);

  return null;
};

export {
  handleEvidonConsentButtonClick,
  setEvidonGDPRConsentCookie,
  haveEvidonCategoriesLoaded,
};

export default EvidonSetConsentHotfix;
